/** Returns a strictly monotonic ISO watermark (never earlier than `current`). */
export function nextContentUpdatedAt(current?: string | null, nowMs = Date.now()): string {
  if (!current) {
    return new Date(nowMs).toISOString();
  }

  const previousMs = Date.parse(current);
  if (Number.isNaN(previousMs)) {
    return new Date(nowMs).toISOString();
  }

  return new Date(Math.max(nowMs, previousMs + 1)).toISOString();
}
